<template>
  <section>
    <Navbar />
    <div id="greyBackground">
      <div class="topAmbassadorInfo">
        <div class="topAmbassadorColumn">
          <div class="ambassadorShown">
            <img class="ambassadorImg" :src="user.profileImage" />
            <p class="boldTitle">{{ user.firstName }} {{ user.lastName }}</p>
          </div>
          <div class="shareInfo" style="margin-top: 20px">
            <div class="shareInfoCol">
              <div v-if="!isViewingLink && !isEditingAddress" class="smallBold">
                Ambassador code
              </div>
              <div class="shareInfo">
                <p
                  v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
                  id="ambassadorCode"
                  class="ambassadorCopy"
                  ref="aCode"
                >
                  {{ ambassadorCode }}
                </p>
                <img
                  @click="editCode()"
                  v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
                  class="portalIcon"
                  src="../assets/PortalPrizes/editPortal.png"
                />
                <img
                  v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
                  class="portalIcon"
                  v-clipboard:copy="ambassadorCode"
                  @click="copyCode()"
                  src="../assets/PortalPrizes/copyPortal.png"
                />
              </div>
            </div>
            <span
              v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
              class="smallDot"
            ></span>
            <div class="shareInfoCol">
              <div v-if="!isEditingCode && !isEditingAddress" class="smallBold">
                Link
              </div>
              <div class="shareInfo">
                <img
                  @click="viewLink()"
                  v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
                  class="portalIcon"
                  src="../assets/PortalPrizes/linkPortal.png"
                />
                <img
                  v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
                  class="portalIcon"
                  v-clipboard:copy="shareLink"
                  @click="copyLink()"
                  src="../assets/PortalPrizes/copyPortal.png"
                />
              </div>
            </div>
            <span
              v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
              class="smallDot"
            ></span>
            <div class="shareInfoCol">
              <div v-if="!isEditingCode && !isViewingLink" class="smallBold">
                Address
              </div>
              <div class="shareInfo">
                <img
                  v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
                  class="portalIconHome"
                  src="../assets/PortalPrizes/homePortal.png"
                />
                <p
                  v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
                  id="ambassadorCode"
                  class="ambassadorCopy ambassadorInfo"
                  @click="editAddress()"
                >
                  {{ address }}
                </p>
                <p
                  v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
                  id="ambassadorCode"
                  class="ambassadorCopy ambassadorInfo"
                  @click="editAddress()"
                >
                  {{ postal }}
                </p>
                <img
                  @click="editAddress()"
                  v-if="!isEditingCode && !isViewingLink && !isEditingAddress"
                  class="portalIcon"
                  src="../assets/PortalPrizes/editPortal.png"
                />
              </div>
            </div>
            <input
              v-if="isEditingCode"
              class="ambassadorEditCode"
              type="text"
              name="newCode"
              v-model="ambassadorCode"
            />
            <p
              v-if="isEditingCode"
              id="ambassadorCode"
              class="ambassadorCopy ambassadorInfoButton ambassadorInfo"
              @click="saveCode()"
            >
              Save
            </p>
            <p
              v-if="isEditingCode"
              id="ambassadorCode"
              class="ambassadorCopy ambassadorInfoButton ambassadorInfo"
              @click="cancelCode()"
            >
              Cancel
            </p>
            <div
              v-if="isViewingLink"
              id="ambassadorCode"
              class="ambassadorCopy"
            >
              courselnk.com/signup/{{ user.id }}
            </div>
            <p
              v-if="isViewingLink"
              id="ambassadorCode"
              class="ambassadorCopy ambassadorInfoButton ambassadorInfo"
              @click="cancelLink()"
            >
              Cancel
            </p>
            <input
              v-if="isEditingAddress"
              class="ambassadorEditCode"
              type="text"
              name="newCode"
              v-model="address"
            />
            <input
              v-if="isEditingAddress"
              class="ambassadorEditCode"
              type="text"
              name="newCode"
              v-model="postal"
            />
            <p
              v-if="isEditingAddress"
              id="ambassadorCode"
              class="ambassadorCopy ambassadorInfoButton ambassadorInfo"
              @click="saveAddress()"
            >
              Save
            </p>
            <p
              v-if="isEditingAddress"
              id="ambassadorCode"
              class="ambassadorCopy ambassadorInfoButton ambassadorInfo"
              @click="cancelAddress()"
            >
              Cancel
            </p>
          </div>
          <p>{{ feedback }}</p>
        </div>
        <div class="topAmbassadorColumn rightAlign" id="selectTotalReferrals">
          <p class="boldTitleSmall">
            Total referrals
          </p>
          <p class="boldTitleBig">
            {{ referralList.length + preAmbassadorReferrals }}
          </p>
        </div>
      </div>

      <div class="loadingContainer whiteStatBox" v-if="!loadedList">
        <div class="loader"></div>
      </div>

      <div class="whiteStatBox" id="mainPortalInfo" v-else>
        <div class="mainPortalTitle">
          <div class="icon">
            <img src="../assets/PortalPrizes/portalStat.svg" />
          </div>
          <p>Portal summary</p>
        </div>
        <div class="portalRow">
          <div class="mainPortalColumn">
            <div class="mainPortalTitle">
              Weekly referrals
            </div>
            <div class="boldTitle">
              {{ weeklyList.reduce((a, b) => a + b, 0) }}
              <span class="portalBarText">this week</span>
            </div>
            <svg
              width="232"
              height="153"
              viewBox="0 0 232 153"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28 10L229 10"
                stroke="#c4c4c4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="weekReferralGraph"
                d="M28 134H43.1289M229 134H214.368M43.1289 134V138M43.1289 134H214.368M214.368 134V138"
                stroke="#c4c4c4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <text x="0" y="15" fill="#818181" font-size="12px">
                {{ weekMax }}
              </text>
              <path
                d="M28 74L229 74"
                stroke="#c4c4c4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="weekReferralPath"
                stroke="#0988e3"
                stroke-width="3"
                stroke-linejoin="round"
              />

              <text x="0" y="78" fill="#818181" font-size="12px">
                {{
                  (weekMax - Math.min.apply(Math, weeklyList)) / 2 +
                    Math.min.apply(Math, weeklyList)
                }}
              </text>
              <text x="0" y="138" fill="#818181" font-size="12px">
                {{ Math.min.apply(Math, weeklyList) }}
              </text>
              <text x="28" y="150" fill="#818181" font-size="12px">
                {{ pastDate }}
              </text>
              <text x="195" y="150" fill="#818181" font-size="12px">
                {{ currentDate }}
              </text>
            </svg>
            <span class="graphHover" id="spanOne">
              <div class="graphLine">
                <span class="graphDot blueDot" id="graphDotOne"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[0] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem blueItem"></div>
                  <p class="boldTitle">
                    {{ weeklyList[0] }}
                    <span class="boldTitleSmall"> referrals</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanTwo">
              <div class="graphLine">
                <span class="graphDot blueDot" id="graphDotTwo"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[1] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem blueItem"></div>
                  <p class="boldTitle">
                    {{ weeklyList[1] }}
                    <span class="boldTitleSmall"> referrals</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanThree">
              <div class="graphLine">
                <span class="graphDot blueDot" id="graphDotThree"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[2] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem blueItem"></div>
                  <p class="boldTitle">
                    {{ weeklyList[2] }}
                    <span class="boldTitleSmall"> referrals</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanFour">
              <div class="graphLine">
                <span class="graphDot blueDot" id="graphDotFour"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[3] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem blueItem"></div>
                  <p class="boldTitle">
                    {{ weeklyList[3] }}
                    <span class="boldTitleSmall"> referrals</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanFive">
              <div class="graphLine">
                <span class="graphDot blueDot" id="graphDotFive"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[4] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem blueItem"></div>
                  <p class="boldTitle">
                    {{ weeklyList[4] }}
                    <span class="boldTitleSmall"> referrals</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanSix">
              <div class="graphLine">
                <span class="graphDot blueDot" id="graphDotSix"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[5] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem blueItem"></div>
                  <p class="boldTitle">
                    {{ weeklyList[5] }}
                    <span class="boldTitleSmall"> referrals</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanSeven">
              <div class="graphLine">
                <span class="graphDot blueDot" id="graphDotSeven"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[6] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem blueItem"></div>
                  <p class="boldTitle">
                    {{ weeklyList[6] }}
                    <span class="boldTitleSmall"> referrals</span>
                  </p>
                </div>
              </div>
            </span>
          </div>
          <div class="mainPortalColumn">
            <div class="mainPortalTitle">
              Daily group activity
            </div>
            <div class="boldTitle">
              {{ dailyActive[dailyActive.length - 1] }}
              <span class="portalBarText">today</span>
            </div>
            <svg
              width="232"
              height="153"
              viewBox="0 0 232 153"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28 10L229 10"
                stroke="#c4c4c4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="weekReferralGraph"
                d="M28 134H43.1289M229 134H214.368M43.1289 134V138M43.1289 134H214.368M214.368 134V138"
                stroke="#c4c4c4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <text x="0" y="15" fill="#818181" font-size="12px">
                {{ groupMax }}
              </text>
              <path
                d="M28 74L229 74"
                stroke="#c4c4c4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="weekJoinedPath"
                stroke="#CD6CD6"
                stroke-width="3"
                stroke-linejoin="round"
              />
              <path
                id="weekActivePath"
                stroke="#1BBF00"
                stroke-width="3"
                stroke-linejoin="round"
              />

              <text x="0" y="78" fill="#818181" font-size="12px">
                {{ (groupMax - groupMin) / 2 + groupMin }}
              </text>
              <text x="0" y="138" fill="#818181" font-size="12px">
                {{ groupMin }}
              </text>
              <text x="28" y="150" fill="#818181" font-size="12px">
                {{ pastDate }}
              </text>
              <text x="195" y="150" fill="#818181" font-size="12px">
                {{ currentDate }}
              </text>
            </svg>
            <span class="graphHover" id="spanOne">
              <div class="graphLine">
                <span class="graphDot pinkDot" id="JoinDotOne"></span>
                <span class="graphDot greenDot" id="ActiveDotOne"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[0] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem greenItem"></div>
                  <p class="boldTitle">
                    {{ dailyActive[0] }}
                    <span class="boldTitleSmall"> active users</span>
                  </p>
                </div>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem purpleItem"></div>
                  <p class="boldTitle">
                    {{ dailyJoined[0] }}
                    <span class="boldTitleSmall"> new users</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanTwo">
              <div class="graphLine">
                <span class="graphDot pinkDot" id="JoinDotTwo"></span>
                <span class="graphDot greenDot" id="ActiveDotTwo"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[1] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem greenItem"></div>
                  <p class="boldTitle">
                    {{ dailyActive[1] }}
                    <span class="boldTitleSmall"> active users</span>
                  </p>
                </div>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem purpleItem"></div>
                  <p class="boldTitle">
                    {{ dailyJoined[1] }}
                    <span class="boldTitleSmall"> new users</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanThree">
              <div class="graphLine">
                <span class="graphDot pinkDot" id="JoinDotThree"></span>
                <span class="graphDot greenDot" id="ActiveDotThree"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[2] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem greenItem"></div>
                  <p class="boldTitle">
                    {{ dailyActive[2] }}
                    <span class="boldTitleSmall"> active users</span>
                  </p>
                </div>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem purpleItem"></div>
                  <p class="boldTitle">
                    {{ dailyJoined[2] }}
                    <span class="boldTitleSmall"> new users</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanFour">
              <div class="graphLine">
                <span class="graphDot pinkDot" id="JoinDotFour"></span>
                <span class="graphDot greenDot" id="ActiveDotFour"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[3] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem greenItem"></div>
                  <p class="boldTitle">
                    {{ dailyActive[3] }}
                    <span class="boldTitleSmall"> active users</span>
                  </p>
                </div>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem purpleItem"></div>
                  <p class="boldTitle">
                    {{ dailyJoined[3] }}
                    <span class="boldTitleSmall"> new users</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanFive">
              <div class="graphLine">
                <span class="graphDot pinkDot" id="JoinDotFive"></span>
                <span class="graphDot greenDot" id="ActiveDotFive"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[4] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem greenItem"></div>
                  <p class="boldTitle">
                    {{ dailyActive[4] }}
                    <span class="boldTitleSmall"> active users</span>
                  </p>
                </div>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem purpleItem"></div>
                  <p class="boldTitle">
                    {{ dailyJoined[4] }}
                    <span class="boldTitleSmall"> new users</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanSix">
              <div class="graphLine">
                <span class="graphDot pinkDot" id="JoinDotSix"></span>
                <span class="graphDot greenDot" id="ActiveDotSix"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[5] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem greenItem"></div>
                  <p class="boldTitle">
                    {{ dailyActive[5] }}
                    <span class="boldTitleSmall"> active users</span>
                  </p>
                </div>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem purpleItem"></div>
                  <p class="boldTitle">
                    {{ dailyJoined[5] }}
                    <span class="boldTitleSmall"> new users</span>
                  </p>
                </div>
              </div>
            </span>
            <span class="graphHover" id="spanSeven">
              <div class="graphLine">
                <span class="graphDot pinkDot" id="JoinDotSeven"></span>
                <span class="graphDot greenDot" id="ActiveDotSeven"></span>
              </div>
              <div class="graphInfo">
                <p>{{ weeklyDays[6] }}</p>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem greenItem"></div>
                  <p class="boldTitle">
                    {{ dailyActive[6] }}
                    <span class="boldTitleSmall"> active users</span>
                  </p>
                </div>
                <div class="menuRowPopup">
                  <div class="colourMenuItem circleItem purpleItem"></div>
                  <p class="boldTitle">
                    {{ dailyJoined[6] }}
                    <span class="boldTitleSmall"> new users</span>
                  </p>
                </div>
              </div>
            </span>
          </div>
          <div class="mainPortalColumn">
            <div class="mainPortalTitle">
              My rewards
            </div>
            <div class="portalBarBox">
              <div class="boldTitleBig">
                {{ score }} <span class="boldTitle">pts</span>
              </div>
              <div class="portalBar"><span id="portalBarFill"></span></div>
              <div v-if="score < 6250" class="portalBarText">
                {{ nextStep - score }} pts left until next reward
              </div>
              <div v-else class="portalBarText">
                0 pts left until next reward
              </div>
              <div class="portalBarText portalAdditionalBox">
                {{ rewardMessage }}
              </div>
            </div>
          </div>
        </div>
        <div class="menuRow">
          <div class="colourMenuItem blueItem"></div>
          <div>total weekly referrals</div>
          <div class="colourMenuItem greenItem"></div>
          <div>active users in your groups</div>
          <div class="colourMenuItem purpleItem"></div>
          <div>new users in your groups</div>
        </div>
      </div>
      <!--div class="whiteStatBox">
        <div class="mainPortalTitle">
          <div class="icon"></div>
          <p>Daily challenges</p>
        </div>

      </div-->
      <div class="whiteStatBox" id="portalBigBar">
        <div class="mainPortalTitle">
          <div class="icon">
            <img src="../assets/PortalPrizes/portalReward.svg" />
          </div>
          <p>Rewards</p>
        </div>
        <!--<div class="portalBar"><span id="portalBarFill"></span></div>-->
        <!--p class="boldTitleBig">{{ score }} pts</p-->
        <!--div id="portalProgressBar">
          <div class="barBox barOne">
            <div class="individualBar">
              <span id="barOneFill"></span>
            </div>
            <span class="barSubtitle">{{ barOneSubtitle }}</span>
          </div>

          <div class="barBox barTwo">
            <div class="individualBar">
              <span id="barTwoFill"></span>
            </div>
            <span class="barSubtitle">{{ barTwoSubtitle }}</span>
          </div>

          <div class="barBox barThree">
            <div class="individualBar">
              <span id="barThreeFill"></span>
            </div>
            <span class="barSubtitle">{{ barThreeSubtitle }}</span>
          </div>

          <div class="barBox barFour">
            <div class="individualBar">
              <span id="barFourFill"></span>
            </div>
            <span class="barSubtitle">{{ barFourSubtitle }}</span>
          </div>

          <div class="barBox barFive">
            <div class="individualBar">
              <span id="barFiveFill"></span>
            </div>
            <span class="barSubtitle">{{ barFiveSubtitle }}</span>
          </div>
        </div>
        <div id="additionalBar">
          <div v-if="score >= 250" class="barOne barCentered">
            <div class="rewardCircle">
              <img
                v-if="sentSticker"
                class="rewardIcon"
                src="../assets/PortalPrizes/checkMark.png"
              />
              <img
                v-else
                class="rewardIconClaimed"
                src="../assets/PortalPrizes/blueReward.png"
              />
            </div>
            <div class="barSubtitle higherBar">{{ barOneSubtitle }}</div>
          </div>
          <div v-if="score >= 1000" class="barTwo barCentered">
            <div class="rewardCircle">
              <img
                v-if="sentShirt"
                class="rewardIcon"
                src="../assets/PortalPrizes/checkMark.png"
              />
              <img
                v-else
                class="rewardIconClaimed"
                src="../assets/PortalPrizes/redReward.png"
              />
            </div>
            <div class="barSubtitle higherBar">{{ barTwoSubtitle }}</div>
          </div>
          <div v-if="score >= 1875" class="barThree barCentered">
            <div class="rewardCircle">
              <img
                v-if="sentBottle"
                class="rewardIcon"
                src="../assets/PortalPrizes/checkMark.png"
              />
              <div
                style="background: black; height: 20px: width: 20px"
                v-if="claimedBottle"
              ></div>
              <img
                v-else
                class="rewardIconClaimed"
                src="../assets/PortalPrizes/greenReward.png"
              />
            </div>
            <span class="barSubtitle higherBar">{{ barThreeSubtitle }}</span>
          </div>
          <div v-if="score >= 3750" class="barFour barCentered">
            <div class="rewardCircle">
              <img
                v-if="sentHat"
                class="rewardIcon"
                src="../assets/PortalPrizes/checkMark.png"
              />
              <img
                v-else
                class="rewardIconClaimed"
                src="../assets/PortalPrizes/pinkReward.png"
              />
            </div>
            <span class="barSubtitle higherBar">{{ barFourSubtitle }}</span>
          </div>
          <div v-if="score >= 6250" class="barFive barCentered">
            <div class="rewardCircle">
              <img
                v-if="sentSweater"
                class="rewardIcon"
                src="../assets/PortalPrizes/checkMark.png"
              />
              <img
                v-else
                class="rewardIconClaimed"
                src="../assets/PortalPrizes/goldReward.png"
              />
            </div>
            <span class="barSubtitle higherBar">{{ barFiveSubtitle }}</span>
          </div>
          <div v-if="score < 6250" class="portalMessage">
            Keep on going!
          </div
        </div-->
        <div class="rewardsTable">
          <div class="rewardsRow">
            <div class="rewardBox" id="stickerReward">
              <div
                class="opacityFilter"
                :class="{ showOpacity: score < 250 }"
              ></div>
              <div class="boldTitle whiteText">Stickers</div>
              <div class="rewardImgBox">
                <img
                  class="rewardImg"
                  src="../assets/PortalPrizes/portalStickers.png"
                />
              </div>
              <div v-if="!claimedSticker && !sentSticker">
                <div
                  v-if="score >= 250"
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  id="orangeClaim"
                  @click="claimSticker()"
                >
                  Claim reward
                </div>
                <div
                  v-else
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                >
                  {{ score }} / 250
                </div>
              </div>
              <div v-else-if="claimedSticker">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #dd9742;"
                >
                  ✅ Claimed reward!
                </div>
              </div>
              <div v-else-if="sentSticker">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #dd9742;"
                >
                  Reward is on its way!
                </div>
              </div>
            </div>
            <div class="rewardBox" id="shirtReward">
              <div
                class="opacityFilter"
                :class="{ showOpacity: score < 1000 }"
              ></div>
              <div class="boldTitle whiteText">Shirt</div>
              <div class="rewardImgBox">
                <img
                  class="rewardImg"
                  src="../assets/PortalPrizes/portalShirt.png"
                />
              </div>
              <div v-if="!claimedShirt && !sentShirt">
                <div
                  v-if="score >= 1000"
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  id="redClaim"
                  @click="claimShirt()"
                >
                  Claim reward
                </div>
                <div
                  v-else
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                >
                  {{ score }} / 1000
                </div>
              </div>
              <div v-else-if="claimedShirt">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #f1515e;"
                >
                  ✅ Claimed reward!
                </div>
              </div>
              <div v-else-if="sentShirt">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #f1515e;"
                >
                  Reward is on its way!
                </div>
              </div>
            </div>
            <div class="rewardBox" id="bottleReward">
              <div
                class="opacityFilter"
                :class="{ showOpacity: score < 1875 }"
              ></div>
              <div class="boldTitle whiteText">Bag and bottle</div>
              <div class="rewardImgBox">
                <img
                  class="rewardImg"
                  src="../assets/PortalPrizes/portalBagBottle.png"
                />
              </div>
              <div v-if="!claimedBottle && !sentBottle">
                <div
                  v-if="score >= 1875"
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  id="pinkClaim"
                  @click="claimBottle()"
                >
                  Claim reward
                </div>
                <div
                  v-else
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                >
                  {{ score }} / 1875
                </div>
              </div>
              <div v-else-if="claimedBottle">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #cd6cd6;"
                >
                  ✅ Claimed reward!
                </div>
              </div>
              <div v-else-if="sentBottle">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #cd6cd6;"
                >
                  Reward is on its way!
                </div>
              </div>
            </div>
          </div>
          <div class="rewardsRow">
            <div class="rewardBox" id="hatReward">
              <div
                class="opacityFilter"
                :class="{ showOpacity: score < 3750 }"
              ></div>
              <div class="boldTitle whiteText">Hat</div>
              <div class="rewardImgBox">
                <img
                  class="rewardImg"
                  src="../assets/PortalPrizes/portalHat.png"
                />
              </div>
              <div v-if="!claimedHat && !sentHat">
                <div
                  v-if="score >= 3750"
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  id="greenClaim"
                  @click="claimHat()"
                >
                  Claim reward
                </div>
                <div
                  v-else
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                >
                  {{ score }} / 3750
                </div>
              </div>
              <div v-else-if="claimedHat">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #1bbf00;"
                >
                  ✅ Claimed reward!
                </div>
              </div>
              <div v-else-if="sentHat">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #1bbf00;"
                >
                  Reward is on its way!
                </div>
              </div>
            </div>
            <div class="rewardBox" id="sweaterReward">
              <div
                class="opacityFilter"
                :class="{ showOpacity: score < 6250 }"
              ></div>
              <div class="boldTitle whiteText">Sweater</div>
              <div class="rewardImgBox">
                <img
                  class="rewardImg"
                  src="../assets/PortalPrizes/portalSweater.png"
                />
              </div>
              <div v-if="!claimedSweater && !sentSweater">
                <div
                  v-if="score >= 6250"
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  id="yellowClaim"
                  @click="claimSweater()"
                >
                  Claim reward
                </div>
                <div
                  v-else
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                >
                  {{ score }} / 6250
                </div>
              </div>
              <div v-else-if="claimedSweater">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #f1c40f;"
                >
                  ✅ Claimed reward!
                </div>
              </div>
              <div v-else-if="sentSweater">
                <div
                  class="portalBarText portalAdditionalBox whiteText rewardClaimButton"
                  style="background: rgba(255, 255, 255, 0.788); color: #f1c40f;"
                >
                  Reward is on its way!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="whiteStatBox whiteBottomBox">
        <div class="mainPortalTitle">
          <div class="icon">
            <img src="../assets/PortalPrizes/portalPoint.svg" />
          </div>
          <p>How do I get points?</p>
        </div>
        <div class="pointTable">
          <div class="pointColumn">
            <div class="mainPortalTitle nonBold">
              <div class="icon">
                <img src="../assets/PortalPrizes/checkMark.png" />
              </div>
              <p>Referring users</p>
            </div>
            <div class="mainPortalTitle nonBold">
              <div class="icon">
                <img src="../assets/PortalPrizes/checkMark.png" />
              </div>
              <p>Completing your profile</p>
            </div>
          </div>
          <div class="pointColumn">
            <div class="mainPortalTitle nonBold">
              <div class="icon">
                <img src="../assets/PortalPrizes/checkMark.png" />
              </div>
              <p>Creating popular chats</p>
            </div>
            <div class="mainPortalTitle nonBold">
              <div class="icon">
                <img src="../assets/PortalPrizes/checkMark.png" />
              </div>
              <p>Participating in chats</p>
            </div>
          </div>
          <div class="pointColumn">
            <div class="mainPortalTitle nonBold">
              <div class="icon">
                <img src="../assets/PortalPrizes/checkMark.png" />
              </div>
              <p>Referred user's profiles</p>
            </div>
            <div class="mainPortalTitle nonBold">
              <div class="icon">
                <img src="../assets/PortalPrizes/checkMark.png" />
              </div>
              <p>Referred user participation</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import db from "@/db";
import { mapState, mapActions } from "vuex";
import Navbar from "@/components/Navbar";
import firebase from "@/firebase";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

export default {
  components: {
    Navbar,
  },
  data: () => ({
    ambassador: null,
    ambassadorCode: null,
    referralList: [],
    additionalPts: 0,
    rewardMessage: "No prizes to claim",
    score: 0,
    referralScore: 0,
    preAmbassadorReferrals: 0,
    nextStep: 0,
    pastDate: "",
    currentDate: "",
    weeklyDays: ["", "", "", "", "", "", ""],
    //weeklyList: [0, 5, 5, 6, 10, 10, 11],
    weeklyList: [0, 0, 0, 0, 0, 0, 0],
    loadedList: false,
    weekMax: 2,
    weekMin: 0,
    //dailyJoined: [1, 0, 5, 2, 3, 0, 0],
    dailyJoined: [0, 0, 0, 0, 0, 0, 0],
    //dailyActive: [3, 5, 7, 8, 1, 4, 9],
    dailyActive: [0, 0, 0, 0, 0, 0, 0],
    groupMin: 0,
    groupMax: 2,
    barOneSubtitle: "claim reward!",
    barTwoSubtitle: "claim reward!",
    barThreeSubtitle: "claim reward!",
    barFourSubtitle: "claim reward!",
    barFiveSubtitle: "claim reward!",
    prevCode: null,
    isEditingCode: false,
    isViewingLink: false,
    isEditingAddress: false,
    feedback: "",
    claimedSticker: false,
    claimedShirt: false,
    claimedBottle: false,
    claimedHat: false,
    claimedSweater: false,
    sentSticker: false,
    sentShirt: false,
    sentBottle: false,
    sentHat: false,
    sentSweater: false,
    isClaiming: false,
    listOfClaims: [],
    address: "",
    postal: "A1A 1A1",
    prevAddress: null,
    prevPostal: null,
    loadedScore: false,
    shareLink: "courselnk.com/signup/",
  }),
  created() {
    this.loadedList = false;
    this.getAmbassadorInfo();
  },
  mounted() {
    //console.log("Mounted");
    this.ambassador = this.user;
    this.getTimestamp();
    //this.setGraphs();
    this.getScore();
    this.shareLink = this.shareLink.concat(this.user.id);
  },
  computed: {
    ...mapState("user", ["user"]),
  },
  methods: {
    ...mapActions("user", ["logout"]),
    async getAmbassadorInfo() {
      await db
        .collection("ambassadorInfo")
        .doc(this.user.id)
        .get()
        .then(async (doc) => {
          //console.log(doc.data());
          if (doc.data().address) {
            this.address = doc.data().address;
            this.prevAddress = doc.data().address;
          } else {
            this.address = "Add your address";
          }
          if (doc.data().postal) {
            this.postal = doc.data().postal;
            this.prevPostal = doc.data().postal;
          }
          if (doc.data().merchClaimed) {
            this.listOfClaims = doc.data().merchClaimed;
          }
          if (doc.data().additionalPoints) {
            this.additionalPts = doc.data().additionalPoints;
          }
          this.ambassadorCode = doc.data().referralCode;
          this.prevCode = doc.data().referralCode;
          //get merch progress
          if (
            doc.data().merchClaimed &&
            doc.data().merchClaimed.includes("stickers")
          ) {
            this.barOneSubtitle = "already claimed";
            this.claimedSticker = true;
          } else if (
            doc.data().merchSent &&
            doc.data().merchSent.includes("stickers")
          ) {
            this.barOneSubtitle = "congratulations";
            this.sentSticker = true;
          }
          if (
            doc.data().merchClaimed &&
            doc.data().merchClaimed.includes("shirt")
          ) {
            this.barTwoSubtitle = "already claimed";
            this.claimedShirt = true;
          } else if (
            doc.data().merchSent &&
            doc.data().merchSent.includes("shirt")
          ) {
            this.barTwoSubtitle = "congratulations";
            this.sentShirt = true;
          }
          if (
            doc.data().merchClaimed &&
            doc.data().merchClaimed.includes("bottle")
          ) {
            this.barThreeSubtitle = "already claimed";
            this.claimedBottle = true;
          } else if (
            doc.data().merchSent &&
            doc.data().merchSent.includes("bottle")
          ) {
            this.barThreeSubtitle = "congratulations";
            this.sentBottle = true;
          }
          if (
            doc.data().merchClaimed &&
            doc.data().merchClaimed.includes("hat")
          ) {
            this.barFourSubtitle = "already claimed";
            this.claimedHat = true;
          } else if (
            doc.data().merchSent &&
            doc.data().merchSent.includes("hat")
          ) {
            this.barFourSubtitle = "congratulations";
            this.sentHat = true;
          }
          if (
            doc.data().merchClaimed &&
            doc.data().merchClaimed.includes("sweater")
          ) {
            this.barFiveSubtitle = "already claimed";
            this.claimedSweater = true;
          } else if (
            doc.data().merchSent &&
            doc.data().merchSent.includes("sweater")
          ) {
            this.barFiveSubtitle = "congratulations";
            this.sentSweater = true;
          }

          await Promise.all(
            doc.data().referralIds.map(async (currentReferral) => {
              //get referrals
              await db
                .collection("users")
                .doc(currentReferral)
                .get()
                .then((doc) => {
                  this.referralList.push(doc.data());
                  if (
                    doc.exists &&
                    doc.data().progressBar.addFriend &&
                    doc.data().progressBar.bio &&
                    doc.data().progressBar.interests &&
                    doc.data().progressBar.joinGroup &&
                    doc.data().progressBar.photos &&
                    doc.data().progressBar.profileImage
                  ) {
                    this.referralScore += 30;
                  } else {
                    this.referralScore += 20;
                  }

                  var extra = this.user.numReferrals;
                  if (extra > 0) {
                    this.referralScore += extra * 20;
                    this.preAmbassadorReferrals = extra;
                  }
                  this.checkTime(doc.data(), "weeklyList");

                  /*this.currentDate = date.toString().slice(4, 10);
                var oldDate = new Date(Date.now() - 6 * 24 * 60 * 60 * 1000);*/
                });
            })
          );
          this.loadedList = true;
          setTimeout(() => {
            this.setGraphs();
            this.score += this.referralScore;
          }, 1);
        });
    },
    onCopy: function(e) {
      alert("You just copied the following text to the clipboard: " + e.text);
    },
    countRewards() {
      var rewardScore = 0;
      if (this.score > 250 && (!this.claimedSticker || !this.sentSticker)) {
        rewardScore++;
      }
      if (this.score > 1000 && (!this.claimedShirt || !this.sentShirt)) {
        rewardScore++;
      }
      if (this.score > 1875 && (!this.claimedBottle || !this.sentBottle)) {
        rewardScore++;
      }
      if (this.score > 3750 && (!this.claimedHat || !this.sentBottle)) {
        rewardScore++;
      }
      if (this.score > 6250 && (!this.claimedSweater || !this.sentSweater)) {
        rewardScore++;
      }

      if (rewardScore != 0) {
        let tempMessage = "Claim ";
        this.rewardMessage = tempMessage.concat(
          rewardScore.toString().concat(" prizes")
        );
      }
    },
    async getScore() {
      var groupScore = 0;

      await db
        .collection("groups")
        .where("admin", "array-contains", this.user.id)
        .get()
        .then(async (doc) => {
          let listOfGroups = [];
          doc.forEach((group) => {
            listOfGroups.push(group.id);
          });

          await Promise.all(
            listOfGroups.map(async (currentGroup) => {
              //.where("chat_id", "in", listOfGroups)
              await db
                .collection("posts")
                .where("chat_id", "==", currentGroup)
                .orderBy("created_at", "desc")
                .get()
                .then((querySnapshot) => {
                  //console.log(querySnapshot);
                  var listJoined = [];
                  var listActivity = new Map();
                  var savedTime = Date.now();
                  var oneDay = 24 * 60 * 60 * 1000;

                  querySnapshot.forEach((doc) => {
                    if (doc.data().created_at < savedTime - oneDay) {
                      savedTime = doc.data().created_at;
                      listJoined = [];
                      listActivity.clear();
                    }

                    if (
                      !doc.data().user_id &&
                      doc.data().content.includes(" joined the group") &&
                      !listJoined.includes(doc.data().content)
                    ) {
                      groupScore += 0.2;
                      this.checkTime(doc.data(), "dailyJoined");
                      listJoined.push(doc.data().content);
                    } else if (
                      doc.data().profileImage &&
                      doc.data().content.length > 1 &&
                      !listActivity.get(doc.data().user_id)
                    ) {
                      groupScore += 0.1;
                      this.checkTime(doc.data(), "dailyActive");
                      listActivity.set(doc.data().user_id, 1);
                    } else if (
                      doc.data().profileImage &&
                      doc.data().content.length > 1 &&
                      listActivity.get(doc.data().user_id) == 25
                    ) {
                      groupScore += 0.1;
                      this.checkTime(doc.data(), "dailyActive");
                      listActivity.set(
                        doc.data().user_id,
                        listActivity.get(doc.data().user_id) + 1
                      );
                    } else if (
                      doc.data().profileImage &&
                      doc.data().content.length > 1
                    ) {
                      listActivity.set(
                        doc.data().user_id,
                        listActivity.get(doc.data().user_id) + 1
                      );
                    }
                  });
                });
            })
          );
          setTimeout(() => {
            //console.log(groupScore);
            this.score += Math.floor(groupScore);
            this.score += this.additionalPts;
            this.getNextStep();
            this.countRewards();
          }, 1);
        });
      //console.log(groupScore);
    },
    checkTime(post, listName) {
      let now = Date.now();
      //console.log(post.created_at > now - 7 * 24 * 60 * 60 * 1000);

      if (post == null) {
        return;
      }
      if (post.created_at > now - 1 * 24 * 60 * 60 * 1000) {
        if (listName == "dailyJoined") {
          this.dailyJoined[6]++;
        } else if (listName == "dailyActive") {
          this.dailyActive[6]++;
        } else if (listName == "weeklyList") {
          this.weeklyList[6]++;
        }
      } else if (post.created_at > now - 2 * 24 * 60 * 60 * 1000) {
        if (listName == "dailyJoined") {
          this.dailyJoined[5]++;
        } else if (listName == "dailyActive") {
          this.dailyActive[5]++;
        } else if (listName == "weeklyList") {
          this.weeklyList[5]++;
        }
      } else if (post.created_at > now - 3 * 24 * 60 * 60 * 1000) {
        if (listName == "dailyJoined") {
          this.dailyJoined[4]++;
        } else if (listName == "dailyActive") {
          this.dailyActive[4]++;
        } else if (listName == "weeklyList") {
          this.weeklyList[4]++;
        }
      } else if (post.created_at > now - 4 * 24 * 60 * 60 * 1000) {
        if (listName == "dailyJoined") {
          this.dailyJoined[3]++;
        } else if (listName == "dailyActive") {
          this.dailyActive[3]++;
        } else if (listName == "weeklyList") {
          this.weeklyList[3]++;
        }
      } else if (post.created_at > now - 5 * 24 * 60 * 60 * 1000) {
        if (listName == "dailyJoined") {
          this.dailyJoined[2]++;
        } else if (listName == "dailyActive") {
          this.dailyActive[2]++;
        } else if (listName == "weeklyList") {
          this.weeklyList[2]++;
        }
      } else if (post.created_at > now - 6 * 24 * 60 * 60 * 1000) {
        if (listName == "dailyJoined") {
          this.dailyJoined[1]++;
        } else if (listName == "dailyActive") {
          this.dailyActive[1]++;
        } else if (listName == "weeklyList") {
          this.weeklyList[1]++;
        }
      } else if (post.created_at > now - 7 * 24 * 60 * 60 * 1000) {
        if (listName == "dailyJoined") {
          this.dailyJoined[0]++;
        } else if (listName == "dailyActive") {
          this.dailyActive[0]++;
        } else if (listName == "weeklyList") {
          this.weeklyList[0]++;
        }
      }
    },
    getNextStep() {
      //console.log("SCORE " + this.score);
      let previousStep = 0;
      if (this.score < 250) {
        this.nextStep = 250;
      } else if (this.score < 1000) {
        previousStep = 250;
        this.nextStep = 1000;
      } else if (this.score < 1875) {
        previousStep = 1000;
        this.nextStep = 1875;
      } else if (this.score < 3750) {
        previousStep = 1875;
        this.nextStep = 3750;
      } else if (this.score < 6250) {
        previousStep = 3750;
        this.nextStep = 6250;
      } else {
        this.nextStep = 0;
      }

      //width: 13%;
      //portalBarFill
      let ratio =
        ((this.score - previousStep) / (this.nextStep - previousStep)) * 100;
      if (ratio < 20) {
        ratio = ratio * 0.35 + 13;
      }
      document.getElementById("portalBarFill").style.width = ratio + "%";
      if (this.score < 250) {
        this.barOneSubtitle = this.score + " / 250";
        this.barTwoSubtitle = this.score + " / 1000";
        this.barThreeSubtitle = this.score + " / 1875";
        this.barFourSubtitle = this.score + " / 3750";
        this.barFiveSubtitle = this.score + " / 6250";
        //document.getElementById("barOneFill").style.width = ratio + "%";
      } else if (this.score < 1000) {
        this.barTwoSubtitle = this.score + " / 1000";
        this.barThreeSubtitle = this.score + " / 1875";
        this.barFourSubtitle = this.score + " / 3750";
        this.barFiveSubtitle = this.score + " / 6250";
        //document.getElementById("barOneFill").style.width = "100%";
        //document.getElementById("barTwoFill").style.width = ratio + "%";
      } else if (this.score < 1875) {
        this.barThreeSubtitle = this.score + " / 1875";
        this.barFourSubtitle = this.score + " / 3750";
        this.barFiveSubtitle = this.score + " / 6250";
        //document.getElementById("barOneFill").style.width = "100%";
        //document.getElementById("barTwoFill").style.width = "100%";
        //document.getElementById("barThreeFill").style.width = ratio + "%";
      } else if (this.score < 3750) {
        this.barFourSubtitle = this.score + " / 3750";
        this.barFiveSubtitle = this.score + " / 6250";
        //document.getElementById("barOneFill").style.width = "100%";
        //document.getElementById("barTwoFill").style.width = "100%";
        //document.getElementById("barThreeFill").style.width = "100%";
        //document.getElementById("barFourFill").style.width = ratio + "%";
      } else if (this.score < 6250) {
        this.barFiveSubtitle = this.score + " / 6250";
        //document.getElementById("barOneFill").style.width = "100%";
        //document.getElementById("barTwoFill").style.width = "100%";
        //document.getElementById("barThreeFill").style.width = "100%";
        //document.getElementById("barFourFill").style.width = "100%";
        //document.getElementById("barFiveFill").style.width = ratio + "%";
      } else {
        //document.getElementById("barOneFill").style.width = "100%";
        //document.getElementById("barTwoFill").style.width = "100%";
        //document.getElementById("barThreeFill").style.width = "100%";
        //document.getElementById("barFourFill").style.width = "100%";
        //document.getElementById("barFiveFill").style.width = "100%";
      }
    },
    getTimestamp() {
      var date = new Date(Date.now());
      this.currentDate = date.toString().slice(4, 10);
      var oldDate = new Date(Date.now() - 6 * 24 * 60 * 60 * 1000);
      this.pastDate = oldDate.toString().slice(4, 10);

      for (var i = 0; i < 7; i++) {
        let tempDate = new Date(Date.now() - i * 24 * 60 * 60 * 1000);

        //weeklyDays
        var preString = "";
        if (tempDate.toString().includes("Mon")) {
          preString = "Monday, ";
        } else if (tempDate.toString().includes("Tue")) {
          preString = "Tuesday, ";
        } else if (tempDate.toString().includes("Wed")) {
          preString = "Wednesday, ";
        } else if (tempDate.toString().includes("Thu")) {
          preString = "Thursday, ";
        } else if (tempDate.toString().includes("Fri")) {
          preString = "Friday, ";
        } else if (tempDate.toString().includes("Sat")) {
          preString = "Saturday, ";
        } else if (tempDate.toString().includes("Sun")) {
          preString = "Sunday, ";
        }
        this.weeklyDays[6 - i] = preString.concat(
          tempDate.toString().slice(4, 10)
        );
        //console.log(this.weeklyDays);
      }
    },
    setGraphs() {
      if (Math.max.apply(Math, this.weeklyList) <= 2) {
        this.weekMax = 2;
      } else {
        this.weekMax = Math.max.apply(Math, this.weeklyList);
      }

      let referralPath = this.setPath(
        this.weeklyList,
        this.weekMax,
        Math.min.apply(Math, this.weeklyList)
      );

      let tempList = this.dailyJoined.concat(this.dailyActive);

      this.groupMin = Math.min.apply(Math, tempList);
      if (Math.max.apply(Math, tempList) <= 2) {
        this.groupMax = 2;
      } else {
        this.groupMax = Math.max.apply(Math, tempList);
      }

      //let tempArray = this.dailyJoined.concat(this.dailyActive);
      let joinedPath = this.setPath(
        this.dailyJoined,
        this.groupMax,
        this.groupMin
      );

      let activePath = this.setPath(
        this.dailyActive,
        this.groupMax,
        this.groupMin
      );

      document
        .getElementById("weekReferralPath")
        .setAttribute("d", referralPath);
      document.getElementById("weekJoinedPath").setAttribute("d", joinedPath);
      document.getElementById("weekActivePath").setAttribute("d", activePath);
      //d="M43 134.379L70 134.3793L99 134.103L128 134.3793L158 134.20L188 134.3793L214 134.3793"
      //"M43 134.379L70 134.3793L99 134.103L128 134.3793L158 134.20L188 134.3793L214 134.3793"

      for (let i = 0; i < 7; i++) {
        var dotHeightWeek = 127 - (this.weeklyList[i] / this.weekMax) * 127;
        if (dotHeightWeek > 5 && dotHeightWeek < 120) {
          dotHeightWeek -= 5;
        }
        var dotStringWeek = dotHeightWeek.toString().concat("px");
        var dotHeightJoined = 127 - (this.dailyJoined[i] / this.groupMax) * 127;
        if (dotHeightJoined > 5 && dotHeightJoined < 120) {
          dotHeightJoined -= 5;
        }
        var dotStringJoined = dotHeightJoined.toString().concat("px");
        var dotHeightActive = 127 - (this.dailyActive[i] / this.groupMax) * 127;
        if (dotHeightActive > 5 && dotHeightActive < 120) {
          dotHeightActive -= 5;
        }
        var dotStringActive = dotHeightActive.toString().concat("px");
        switch (i) {
          case 0:
            document.getElementById(
              "graphDotOne"
            ).style.marginTop = dotStringWeek;

            document.getElementById(
              "JoinDotOne"
            ).style.marginTop = dotStringJoined;
            document.getElementById(
              "ActiveDotOne"
            ).style.marginTop = dotStringActive;
            break;
          case 1:
            document.getElementById(
              "graphDotTwo"
            ).style.marginTop = dotStringWeek;
            document.getElementById(
              "JoinDotTwo"
            ).style.marginTop = dotStringJoined;
            document.getElementById(
              "ActiveDotTwo"
            ).style.marginTop = dotStringActive;
            break;
          case 2:
            document.getElementById(
              "graphDotThree"
            ).style.marginTop = dotStringWeek;
            document.getElementById(
              "JoinDotThree"
            ).style.marginTop = dotStringJoined;
            document.getElementById(
              "ActiveDotThree"
            ).style.marginTop = dotStringActive;
            break;
          case 3:
            document.getElementById(
              "graphDotFour"
            ).style.marginTop = dotStringWeek;
            document.getElementById(
              "JoinDotFour"
            ).style.marginTop = dotStringJoined;
            document.getElementById(
              "ActiveDotFour"
            ).style.marginTop = dotStringActive;
            break;
          case 4:
            document.getElementById(
              "graphDotFive"
            ).style.marginTop = dotStringWeek;
            document.getElementById(
              "JoinDotFive"
            ).style.marginTop = dotStringJoined;
            document.getElementById(
              "ActiveDotFive"
            ).style.marginTop = dotStringActive;
            break;
          case 5:
            document.getElementById(
              "graphDotSix"
            ).style.marginTop = dotStringWeek;
            document.getElementById(
              "JoinDotSix"
            ).style.marginTop = dotStringJoined;
            document.getElementById(
              "ActiveDotSix"
            ).style.marginTop = dotStringActive;
            break;
          case 6:
            document.getElementById(
              "graphDotSeven"
            ).style.marginTop = dotStringWeek;
            document.getElementById(
              "JoinDotSeven"
            ).style.marginTop = dotStringJoined;
            document.getElementById(
              "ActiveDotSeven"
            ).style.marginTop = dotStringActive;
            break;
        }
      }
    },
    setPath(graphNums, graphMax, graphMin) {
      let graphPath = "M43 ";

      graphNums.forEach((item, index) => {
        let dayPoint = 134 - ((item - graphMin) / (graphMax - graphMin)) * 134;
        if (dayPoint < 10) {
          dayPoint = 10;
        }
        let dayString = Math.round(dayPoint);
        graphPath = graphPath.concat(dayString.toString());
        switch (index) {
          case 0:
            graphPath = graphPath.concat(".379L70 ");
            break;
          case 1:
            graphPath = graphPath.concat(".3793L99 ");
            break;
          case 2:
            graphPath = graphPath.concat(".103L128 ");
            break;
          case 3:
            graphPath = graphPath.concat(".3793L158 ");
            break;
          case 4:
            graphPath = graphPath.concat(".20L188 ");
            break;
          case 5:
            graphPath = graphPath.concat(".3793L214 ");
            break;
          case 6:
            graphPath = graphPath.concat(".3793");
            break;
        }
      });

      return graphPath;
    },
    editCode() {
      this.isEditingCode = true;
      this.prevCode = this.ambassadorCode;
    },
    copyCode() {
      this.feedback = "Copied ambassador code!";
      setTimeout(() => {
        this.feedback = "";
      }, 2000);
    },
    editAddress() {
      this.isEditingAddress = true;
      this.prevAddress = this.address;
      this.prevPostal = this.postal;
    },
    viewLink() {
      this.isViewingLink = true;
    },
    copyLink() {
      this.feedback = "Copied share link!";
      setTimeout(() => {
        this.feedback = "";
      }, 2000);
    },
    saveCode() {
      //let goodCode = false;
      if (this.ambassadorCode.length > 30) {
        //make sure new code isn't too long
        this.feedback = "Your new code can't be longer than 30 characters";
      } else if (this.ambassadorCode.length < 4) {
        //make sure new code isn't too short
        this.feedback = "Your new code can't be shorter than 4 characters";
      } else {
        //make sure this code doesn't already exist
        db.collection("ambassadorInfo")
          .where("referralCode", "==", this.ambassadorCode)
          .get()
          .then((doc) => {
            let tempNum = 0;
            doc.forEach((docs) => {
              if (docs.id == this.user.id) {
                console.log("h");
              } else {
                tempNum++;
              }
            });
            if (tempNum > 0) {
              this.feedback =
                "Sorry, another ambassador has already chosen this code, please pick a new one";
            } else {
              this.feedback = "";
              this.isEditingCode = false;
              db.collection("ambassadorInfo")
                .doc(firebase.auth().currentUser.uid)
                .update({
                  referralCode: this.ambassadorCode,
                });
            }
          });
      }
    },
    saveAddress() {
      console.log(this.postal.length);
      if (this.address.length > 30) {
        //make sure new code isn't too long
        this.feedback = "Your address can't be longer than 30 characters";
      } else if (this.address.length < 4) {
        //make sure new code isn't too short
        this.feedback = "Your address can't be shorter than 4 characters";
      } else if (this.postal.length != 6 && this.postal.length != 7) {
        this.feedback =
          "Your postal code must be 6 characters long or 7 with a space";
      } else {
        db.collection("ambassadorInfo")
          .doc(firebase.auth().currentUser.uid)
          .update({
            address: this.address,
            postal: this.postal,
          });
        this.isEditingAddress = false;
        this.feedback = "";
      }
    },
    cancelAddress() {
      this.feedback = "";
      this.isEditingAddress = false;
      this.address = this.prevAddress;
      this.postal = this.prevPostal;
      db.collection("ambassadorInfo")
        .doc(firebase.auth().currentUser.uid)
        .update({
          address: this.prevAddress,
          postal: this.prevPostal,
        });
    },
    cancelCode() {
      this.feedback = "";
      this.isEditingCode = false;
      this.ambassadorCode = this.prevCode;
      db.collection("ambassadorInfo")
        .doc(firebase.auth().currentUser.uid)
        .update({
          referralCode: this.prevCode,
        });
    },
    cancelLink() {
      this.isViewingLink = false;
    },
    listChallenges() {
      //talk in 4 chats
      //have 5 people talk in your chats
      //send 20 messages
      //refer one person
      //
    },
    claimSticker() {
      this.claimedSticker = true;
      this.claimMerch("stickers");
    },
    claimShirt() {
      this.claimedShirt = true;
      this.claimMerch("shirt");
    },
    claimBottle() {
      this.claimedBottle = true;
      this.claimMerch("bottle");
    },
    claimHat() {
      this.claimedHat = true;
      this.claimMerch("hat");
    },
    claimSweater() {
      this.claimedSweater = true;
      this.claimMerch("sweater");
    },
    claimMerch(name) {
      this.listOfClaims.push(name);
      console.log(this.listOfClaims);
      db.collection("ambassadorInfo")
        .doc(firebase.auth().currentUser.uid)
        .update({
          merchClaimed: this.listOfClaims,
        });
    },
  },
};
</script>

<style src="@/styles/views/Portal.css"></style>
